import Vue from 'vue'
import Router from 'vue-router'

import index from './components/Templates/modulos/Index/index'


import profileuser from './components/Templates/modulos/Usuarios/profileuser'

//import PerfildeSedes from './components/Templates/modulos/Empresa/PerfildeSedes'
import comments from './components/Templates/modulos/Comments/comments'
import projects from './components/Templates/modulos/Projects/projects'
import Projectdetail from './components/Templates/modulos/Projects/projectsdetail'
import searchprojects from './components/Templates/modulos/Projects/searchproject'
import fileprojects from './components/Templates/modulos/Usuarios/fileprojects'


import publications from './components/Templates/modulos/Publications/publications'

let language = JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : ''

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path:'/projectsdetail/:idproject',
      name:'Projectsdetail',
      component:Projectdetail,
      
    },
    {
      path:'/searchproject/:searchname',
      name:'SearchProjects',
      component:searchprojects,
      meta:{
        title:language==='English'?'Search Projects':'Buscar Proyectos',
      }
    },
    {
      path:'/projects',
      name:'Projects',
      component:projects,
      meta:{
        title:language==='English'?'My Projects':'Mis Proyectos',
      }
    },
    {
      path:'/comments/:idproject',
      name:'Comentarios',
      component:comments,
      meta:{
        title:'Comentarios',
      }
    },              
    {
      path: '/',
      name: 'Index',
      component: index,
        meta:{
            title: language==='English'?'Fs Amta - Welcome':'Fs Amta - Bienvenido',
            //auth: false,
        }
    },
    {
      path: '/projects/:idproject',
      name: 'fileprojects',
      component: fileprojects,
        meta:{
            title: '',
            //auth: false,
        }
    },
    {
      path:'/:nameuser',
      name:'Profileuser',
      component:profileuser,
      meta:{
        title:'',
        auth:true,
      }
    },
    {
      path:'/post/publications',
      name:'Publications',
      component:publications,
      meta:{
        title:language==='English'?'Fs Amta - Publications':'Fs Amta - Publicaciones',
        auth:true,
      }
    }
  ]
})
